import React from 'react';
import * as moment from 'moment';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';

import {
    Document,
    Page,
    Text,
    View,
    StyleSheet
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
    view: {
        flexDirection: 'row',
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
        fontSize: 10
    }
});

const PdfDocument = props => (
    <Document>
        <Page size="A4" >
            <Text style={{ fontSize: 15, padding: 10, margin: 10, textAlign: 'center' }}> Return Authorization Form </Text>
            <View style={styles.view}>
                <View style={styles.section}>
                    <Text>Ship From</Text>
                    <Text>  </Text>
                    <Text> {props.pdfDocumentData.shipFrom.line1}&nbsp;</Text>
                    <Text> {props.pdfDocumentData.shipFrom.city}&nbsp; {props.pdfDocumentData.shipFrom.state}  </Text>
                </View>

                <View style={styles.section}>
                    <Text>Ship To</Text>
                    <Text>  </Text>
                    <Text> {props.pdfDocumentData.shipTo.line1}&nbsp;</Text>
                    <Text> {props.pdfDocumentData.shipTo.city}&nbsp; {props.pdfDocumentData.shipTo.state}  </Text>
                </View>

                <View style={styles.section}>
                    <Text>Order Info </Text>
                    <Text>  </Text>
                    <Text>PO No.: {props.pdfDocumentData.poNumber} </Text>
                    <Text>Quantity: {props.pdfDocumentData.quantity} </Text>
                    <Text>Grade: {props.pdfDocumentData.grade.gradeName} </Text>
                    <Text>Posted Date: {moment(props.postedOn).format(FORMAT)} </Text>
                    <Text>Transportation: {props.pdfDocumentData.addressType} </Text>
                    {props.pdfDocumentData.rescheduleOrder ? <>
                        <Text>Rescheduled Date:
                                        {props.pdfDocumentData.claimRaisedUserType === 'raiseClaim' && <>{moment(props.pdfDocumentData.rescheduleOrder.buyerRescheduledDate).format(FORMAT)}</>}
                            {props.pdfDocumentData.claimRaisedUserType !== 'raiseClaim' && <>{moment(props.pdfDocumentData.rescheduleOrder.sellerRescheduledDate).format(FORMAT)}</>}
                        </Text>
                    </> : <>
                            <Text>Expected Delivery Date:
                                        {props.pdfDocumentData.claimRaisedUserType === 'raiseClaim' && <>{props.pdfDocumentData.shippingStatusDetails && moment(props.pdfDocumentData.shippingStatusDetails[1].createdBuyerTime).format(FORMAT)}</>}
                                {props.pdfDocumentData.claimRaisedUserType !== 'raiseClaim' && <>{props.pdfDocumentData.shippingStatusDetails && moment(props.pdfDocumentData.shippingStatusDetails[1].createdSellerTime).format(FORMAT)}</>}
                            </Text>
                        </>}


                </View>

                <View style={styles.section}>
                    <Text>Claim Detail </Text>
                    <Text>  </Text>
                    <Text>Total Quantity: {props.pdfDocumentData.quantity}</Text>
                    <Text>Issue Type: {props.pdfDocumentData.issueType === 'BOTH' ? "Quality/Quantity" : props.pdfDocumentData.issueType}</Text>
                    {props.pdfDocumentData.issueType === 'BOTH' && <><Text>Issue Quality/Quantity: {props.pdfDocumentData.totalPalletQuality + props.pdfDocumentData.totalPalletQuantity}</Text></>}
                    {props.pdfDocumentData.issueType === 'QUANTITY' && <><Text>Issue Quantity: {props.pdfDocumentData.totalPalletQuantity}</Text></>}
                    {props.pdfDocumentData.issueType === 'QUALITY' && <><Text>Issue Quality: {props.pdfDocumentData.totalPalletQuality}</Text></>}
                    <Text>Total Cost: $ {(props.pdfDocumentData.quantity * props.pdfDocumentData.pricePerPallet).toFixed(2)}</Text>
                    <Text>Issue Cost: $ {props.pdfDocumentData.claimTotalPrice.toFixed(2)}</Text>
                </View>
            </View>
        </Page>
    </Document>
);

export default PdfDocument;